export default async ({
  sessionId = '',
  filename = ''
}) => {
  const [content, error, status] = await POST(URLS.kpi.projAppraise.deleteProjAppraiseAttachment, {
    sessionId,
    filename
  });
  if (error) return {
    error,
    status
  };
  return content || {
    sessionId,
    filename
  };
};